// LËTZEBUERGESCH — Iwwersetzung als Liesehëllef. Nëmmen déi franséisch Fassung gëllt (kuck fr.js).

import { COURRIEL, TELEPHONE, adresseVendeur, encadreIdentite } from './identite';

const ADRESSE = adresseVendeur('Belsch');
const TRADUCTION =
  'Dës Iwwersetzung gëtt Iech als Liesehëllef ugebueden. Bei Ënnerscheeder gëllt eleng déi franséisch Fassung.';

export default {
  cgv: {
    seoTitre: 'Allgemeng Verkafsbedingungen',
    seoDescription:
      'Allgemeng Verkafsbedingunge vu MirumGames: Bestellung, Präisser, Bezuelung, 14 Deeg Widderrufsrecht, Liwwerung a Garantien.',
    titre: 'Allgemeng Verkafsbedingungen',
    maj: 'Lescht Aktualiséierung: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Artikel 1: Allgemengt',
        blocs: [
          { p: 'All Bestellung op MIRUMGAMES.COM setzt d’Unerkennung vun dësen allgemenge Bedingungen viraus. De Client bestätegt, hiren Inhalt ouni Virbehalt gelies an ugeholl ze hunn.' },
        ],
      },
      {
        titre: 'Artikel 2: Géigestand',
        blocs: [
          { p: 'Dës allgemeng Bedingunge leeë Rechter a Flichte vun de Parteie fest, déi um Onlineverkaf vun de Produkter an Déngschtleeschtunge vu MirumGames.com bedeelegt sinn.' },
        ],
      },
      {
        titre: 'Artikel 3: Präisser a Bezuelung',
        blocs: [
          { p: 'D’Präisser sinn an Euro an enthalen déi gëlteg TVA. D’Liwwerkäschte sinn net abegraff a ginn separat verrechent. Déi voll Bezuelung geschitt, wann d’Bestellung bestätegt gëtt.' },
          { p: 'MirumGames.com akzeptéiert Kaartebezuelungen iwwer STRIPE, e certifiéierten a séchere Bezuelungsdéngschtleeschter.' },
          { p: 'Fir all bezuelt Bestellung gëtt eng Rechnung op den Numm vum Keefer ausgestallt. Dir fannt se op der Bestätegungssäit vun der Bestellung, iwwer de Link an der Bestätegungs-E-Mail an, wann Dir e Kont hutt, ënner „Meng Bestellungen“. Stripe schéckt Iech dozou nach eng Bezuelungsquittung per E-Mail.' },
        ],
      },
      {
        titre: 'Artikel 4: Widderrufsrecht',
        blocs: [
          { p: 'All privaten Client huet 14 Deeg Zäit, fir Produkter zréckzeschécken, déi him net passen. D’Frist fänkt um Dag vun der Liwwerung un.' },
          { p: 'Bedingunge fir d’Retour:' },
          {
            liste: [
              'D’Produkter musse an hirer Originalverpackung an a perfektem, weiderverkeefbarem Zoustand zréckgeschéckt ginn',
              'Produkter mat Gebrauchsspure ginn net ugeholl',
              'D’Retourkäschte gi vum Client gedroen',
              'D’Erstattung geschitt bannent 15 Deeg per Iwwerweisung',
            ],
          },
        ],
      },
      {
        titre: 'Artikel 5: Kommerziell Garantie',
        blocs: [
          { p: 'MirumGames.com garantéiert d’Produkter géint verstoppte Mängel no belschem Recht. MirumGames.com ass net den Hiersteller vun den ugebuedenen Artikelen a léint all Haftung fir Schued of, deen duerch e Produktfehler entstoe kann.' },
          { p: 'D’Haftung vum Verkeefer beschränkt sech op den Ëmtausch oder d’Erstattung vum defektem Produkt.' },
        ],
      },
      {
        titre: 'Artikel 6: Disponibilitéit vun de Produkter',
        blocs: [
          { p: 'D’Offere gëlle sou laang de Stock duerch ass. Biller, Faarwen, Moossen a Gewiichte sinn nëmmen informativ an net vertraglech. MirumGames.com léint all Haftung fir Ofwäichungen an de Produkteegenschaften of.' },
        ],
      },
      {
        titre: 'Artikel 7: Liwwerung',
        blocs: [
          { p: 'D’Produkter gi op d’Adress geliwwert, déi de Client um Bestellformulaire ugëtt. Dat muss eng physesch Adress sinn (kee Postfach).' },
          { p: 'Mir schécken an d’Belsch, a Frankräich, a Lëtzebuerg, an d’Nidderlanden, an Däitschland an a Spuenien. Duerchschnëttlech Liwwerzäiten:' },
          {
            liste: [
              'Lëtzebuerg, Belsch, Nidderlanden: 1 bis 2 Aarbechtsdeeg',
              'Frankräich, Däitschland: 2 bis 4 Aarbechtsdeeg',
              'Spuenien: 4 bis 5 Aarbechtsdeeg',
            ],
          },
          { p: 'Notiz: D’Virbereedungszäit (am Duerchschnëtt 1 Aarbechtsdag) kënnt nach dobäi.' },
        ],
      },
      {
        titre: 'Artikel 8: Konformitéit vun der Liwwerung',
        blocs: [
          { p: 'Beim Empfang muss de Client iwwerpréiwen, ob d’Produkter mat der Bestellung iwwereneestëmmen. All Mangel muss mat der Hand um Liwwerschäin agedroe ginn.' },
          { p: 'All Ofwäichung (feelend oder beschiedegt Produkt asw.) muss MirumGames.com bannent 96 Stonnen no der Versandmeldung matgedeelt ginn.' },
        ],
      },
      {
        titre: 'Artikel 9: Haftung',
        blocs: [
          { p: 'MirumGames.com kann net haftbar gemaach gi fir Schued, deen no der Liwwerung duerch falsch Notzung oder onsaachgeméiss Handhabung vun de Produkter entsteet.' },
        ],
      },
      {
        titre: 'Artikel 10: Uwendbart Recht',
        blocs: [
          { p: 'Dës allgemeng Bedingunge ënnerleien dem belsche Recht. Am Fall vun engem Sträit gëtt de Client gebieden, fir d’éischt MirumGames.com ze kontaktéieren, fir eng gëttlech Léisung ze fannen.' },
        ],
      },
      {
        titre: 'Rechtlech Hiweiser',
        blocs: [
          { p: 'Déi komplett rechtlech Donnéeë vum Betrib (Kontakt, TVA asw.) fannt Dir op eiser <a href="/legal" class="text-blue-600 hover:text-blue-800 underline">Säit mat de rechtlechen Hiweiser</a>.' },
          { p: 'Bei de Bestellungen, där hir Bezuelung bis an den 22/09/2026 abegraff (belsch Zäit) ukomm ass, ass d’Charlotte Ansiaux (BCE 1000.107.018) d’Verkeeferin a bleift et; bei de Bestellungen, där hir Bezuelung vum 23/09/2026 un ukënnt, ass de Sébastien Schoonjans de Verkeefer.' },
        ],
      },
    ],
  },

  confidentialite: {
    seoTitre: 'Dateschutzerklärung',
    seoDescription:
      'Dateschutzerklärung vu MirumGames: gesammelt Donnéeën, Notzung, Cookien, anonym Publikumsmiessung an Är Rechter no der DSGVO.',
    titre: 'Dateschutzerklärung',
    maj: 'Lescht Aktualiséierung: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: '1. Sammele vu perséinlechen Donnéeën',
        blocs: [
          { p: 'MirumGames.com sammelt déi perséinlech Donnéeën, déi néideg sinn, fir:' },
          {
            liste: [
              'Är Bestellung ze bearbechten (Numm, Adress, E-Mail, Telefon)',
              'Iech Bestellbestätegungen a Liwwermeldungen ze schécken',
              'Äre Clientskont ze verwalten',
              'Iech eis Newsletteren ze schécken (mat Ärer Zoustëmmung)',
              'Eis Servicer ze verbesseren',
            ],
          },
        ],
      },
      {
        titre: '2. Notzung vun den Donnéeën',
        blocs: [
          { p: 'Är Donnéeë ginn nëmme fir déi uewe genannten Zwecker benotzt. MirumGames.com gëtt Är Donnéeën ni un Drëtter weider ouni Är ausdrécklech Zoustëmmung.' },
          { p: 'Déi eenzeg Ausnamen sinn:' },
          {
            liste: [
              'D’Logistiksdéngschtleeschter fir d’Liwwerung',
              'STRIPE fir d’Verschaffe vun de Bezuelungen',
              'D’Autoritéiten, wann d’Gesetz et verlaangt',
            ],
          },
        ],
      },
      {
        titre: '3. Cookien',
        blocs: [
          { p: 'MirumGames.com benotzt Cookien, fir Är Erfarung ze verbesseren, besonnesch fir:' },
          {
            liste: [
              'Är Navigatiounspreferenzen ze behalen',
              'Äre Kuerf ze verwalten',
              'Är Erfarung ze perséinaliséieren',
            ],
          },
          { p: 'Dir kënnt Cookien zu all Moment an den Astellunge vun Ärem Browser ausschalten. Dat kann awer d’Funktionéiere vum Site beaflossen.' },
          { p: '<strong>Publikumsmiessung:</strong> Mir benotzen eng eege Besucherzielung, ouni Cookie an ouni perséinlech Donnéeën. Weder Är IP-Adress nach Är Navigatiounsgeschicht gi gespäichert: et ginn nëmmen aggregéiert an anonym Statistiken erstallt (ugekuckte Säiten, Besucher pro Dag). Domat kënne mir Iech weder vun engem Dag op deen aneren nach vun engem Site op deen aneren verfollegen, an Dir kënnt d’Miessung zu all Moment iwwer de Link „Meng Cookien verwalten“ ënnen op der Säit refuséieren.' },
        ],
      },
      {
        titre: '4. Är Rechter (DSGVO)',
        blocs: [
          { p: 'Als Awunner an Europa hutt Dir folgend Rechter:' },
          {
            liste: [
              '<strong>Recht op Auskonft:</strong> Dir kënnt Zougang zu Äre perséinlechen Donnéeë froen',
              '<strong>Recht op Berichtegung:</strong> Dir kënnt falsch Donnéeë korrigéiere loossen',
              '<strong>Recht op Läschung:</strong> Dir kënnt d’Läsche vun Ären Donnéeë froen',
              '<strong>Recht op Aschränkung:</strong> Dir kënnt d’Veraarbechtung vun Ären Donnéeën aschränken',
              '<strong>Recht op Iwwerdroegbarkeet:</strong> Dir kënnt Är Donnéeën an engem strukturéierte Format kréien',
              '<strong>Recht op Widdersproch:</strong> Dir kënnt der Veraarbechtung vun Ären Donnéeë widderspriechen',
            ],
          },
          { p: `Fir dës Rechter auszeüben, kontaktéiert ${COURRIEL}.` },
        ],
      },
      {
        titre: '5. Sécherheet vun den Donnéeën',
        blocs: [
          { p: 'MirumGames.com setzt passend technesch an organisatoresch Sécherheetsmoossnamen an, fir Är Donnéeën ze schützen:' },
          {
            liste: [
              'SSL/TLS-Verschlësselung vun all de Verbindungen',
              'Ageschränkten Zougang zu de perséinlechen Donnéeën',
              'Reegelméisseg Datesécherungen',
              'Anhalen vun der DSGVO',
            ],
          },
        ],
      },
      {
        titre: '6. Späicherdauer',
        blocs: [
          { p: 'Är perséinlech Donnéeë gi sou laang gespäichert, wéi et néideg ass fir:' },
          {
            liste: [
              'D’Ofwécklung vun Ärer Bestellung an de Garantien',
              'D’Anhale vu gesetzleche Flichten (besonnesch steierlechen)',
              'D’Verwaltung vun Ärem Clientskont',
            ],
          },
          { p: 'No dëser Period ginn Är Donnéeë geläscht oder anonymiséiert.' },
        ],
      },
      {
        titre: '7. Drëtter',
        blocs: [
          { p: 'MirumGames.com kann Är Donnéeë mat de folgenden Déngschtleeschter deelen:' },
          {
            liste: [
              '<strong>STRIPE</strong>: fir d’Verschaffe vun de Bezuelungen',
              '<strong>Sendcloud</strong>: fir d’Verwalte vum Versand an de Liwwerungen',
              '<strong>Sentry</strong>: fir d’Mellung vun techneschen Feeler um Site. Et ginn nëmmen déi Informatiounen iwwerdroen, déi néideg si fir eng Pann ze diagnostizéieren; et gëtt keng Opnam vun Ärer Navigatioun gemaach.',
              '<strong>Hosting</strong>: fir d’Späichere vum Site an den Donnéeën',
            ],
          },
          { p: 'All dës Déngschtleeschter si verflicht, d’Vertraulechkeet vun Ären Donnéeën ze respektéieren.' },
        ],
      },
      {
        titre: '8. Kontakt',
        blocs: [
          { p: 'Fir all Fro zu Ärer Privatsphär, kontaktéiert:' },
          { p: `<strong>Verantwortleche fir d’Veraarbechtung:</strong> Sébastien Schoonjans (MirumGames.com)<br /><strong>E-Mail:</strong> ${COURRIEL}<br /><strong>Adress:</strong> ${ADRESSE}` },
          { p: 'D’Donnéeë vun de bestoende Clientskonte goufen den 23/09/2026 zesumme mat der Aktivitéit vum Site vum Sébastien Schoonjans iwwerholl.' },
        ],
      },
    ],
  },

  mentions: {
    seoTitre: 'Rechtlech Hiweiser',
    seoDescription:
      'Rechtlech Hiweiser vu MirumGames: Betribsinformatiounen, Besëtzer vum Site, TVA-Nummer a Kontaktdonnéeën.',
    titre: 'Rechtlech Hiweiser',
    maj: 'Lescht Aktualiséierung: 23/09/2026',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Informatiounen iwwer de Betrib',
        blocs: [
          {
            encadre: encadreIdentite({
              nom: 'Numm vum Betrib',
              statut: 'Statut',
              statutValeur: 'selbststännegen Entrepreneur (natierlech Persoun)',
              adresse: 'Adress',
              pays: 'Belsch',
              bce: 'Betribsnummer (BCE)',
              tva: 'TVA-Nummer',
              email: 'E-Mail',
              telephone: 'Telefon',
              sep: ':',
            }),
          },
        ],
      },
      {
        titre: 'Verantwortlech fir d’Publikatioun',
        blocs: [
          { p: '<strong>Sébastien Schoonjans</strong><br />Verantwortlech fir d’Publikatioun vum Site MirumGames.com' },
        ],
      },
      {
        titre: 'Hosting vum Site',
        blocs: [
          { p: 'De Site MirumGames.com gëtt gehost vun:<br /><strong>Cloudflare Pages</strong> (ëffentlech Uewerfläch)<br /><strong>Dedizéierte Server</strong> (Applikatioun an Datebank)<br /><br />D’Donnéeë ginn an der Europäescher Unioun gehost a no der DSGVO veraarbecht.' },
        ],
      },
      {
        titre: 'Geeschtegt Eegentum',
        blocs: [
          { p: 'Den ganzen Inhalt vum Site MirumGames.com (Texter, Biller, Illustratiounen, Logoen, Videoen asw.) ass duerch d’Gesetzer iwwer d’geeschtegt Eegentum geschützt.' },
          { p: 'All Reproduktioun, Duerstellung, Ännerung, Verëffentlechung oder Upassung vum ganze Site oder Deeler dovun, egal mat wéi engem Mëttel, ass ouni virdru schrëftlech Erlaabnis vum Editeur vum Site, dem Sébastien Schoonjans, verbueden.' },
        ],
      },
      {
        titre: 'Steieren an Ofgaben',
        blocs: [
          { p: 'Mir maachen Iech opmierksam, datt eis Präisser d’Steieren an Ofgaben enthalen, déi an der Belsch gëllen. D’Gesetzgebung ass vu Land zu Land verschidden.' },
          { p: 'De Keefer iwwerpréift, ob a sengem Wunnsëtzland weider Steieren oder Ofgabe fällis ginn, a bezilt gegebenenfalls all Ofgaben, Steieren a Käschte vun all Aart fir d’Produkter, déi hien a sengem Land agefouert huet.' },
        ],
      },
      {
        titre: 'Haftungsbeschränkung',
        blocs: [
          { p: 'Den Editeur vum Site bemitt sech, d’Informatiounen op dësem Site richteg an aktuell ze halen, a behält sech d’Recht vir, den Inhalt zu all Moment an ouni Virwarnung ze korrigéieren.' },
          { p: 'Den Editeur kann awer d’Richtegkeet, d’Genauegkeet oder d’Vollstännegkeet vun den zur Verfügung gestallten Informatiounen net garantéieren.' },
        ],
      },
      {
        titre: 'Cookien a perséinlech Donnéeën',
        blocs: [
          { p: 'All Informatioun zur Notzung vu Cookien an zum Schutz vun Äre perséinlechen Donnéeë fannt Dir an eiser <a href="/privacy" class="text-blue-600 hover:text-blue-800 underline">Dateschutzerklärung</a>.' },
        ],
      },
      {
        titre: 'Uwendbart Recht',
        blocs: [
          { p: 'Dës rechtlech Hiweiser ënnerleien dem belsche Recht. Am Fall vun engem Sträit wennt sech de Client prioritär u MirumGames.com, fir eng gëttlech Léisung ze fannen.' },
          { p: 'Soss gëtt de Sträit der exklusiver Zoustännegkeet vun de zoustännege belsche Geriichter ënnerworf.' },
        ],
      },
      {
        titre: 'Kontakt',
        blocs: [
          { p: `Fir all Fro zu dëse rechtlechen Hiweiser kënnt Dir eis erreechen ënner:<br /><strong>E-Mail:</strong> ${COURRIEL}<br /><strong>Adress:</strong> ${ADRESSE}<br /><strong>Telefon:</strong> ${TELEPHONE}` },
        ],
      },
    ],
  },

  paiement: {
    seoTitre: 'Sécher bezuelen',
    seoDescription:
      'Bezuelungssécherheet bei MirumGames: Transaktiounen iwwer Stripe, SSL/TLS-Verschlësselung, PCI-DSS-Zertifizéierung a praktesch Rotschléi.',
    titre: 'Sécher bezuelen',
    maj: 'Lescht Aktualiséierung: 18/02/2024',
    mentionTraduction: TRADUCTION,
    sections: [
      {
        titre: 'Bezuele mat STRIPE',
        blocs: [
          { p: 'D’Sécherheet vu Bankstransaktiounen ass vun héchster Wichtegkeet. MirumGames.com setzt dofir op d’Expertise vu STRIPE, fir Är Bezuelunge bestméiglech ze schützen.' },
        ],
      },
      {
        titre: 'Ass et sécher, bei MirumGames ze bezuelen?',
        blocs: [
          { p: 'Jo. Wärend der Bezuelung leeft déi ganz Transaktioun verschlësselt iwwer STRIPE. Dir verlooss MirumGames.com kuerz a ganz transparent, fir Är Bankdonnéeën anzeginn.' },
          { p: 'Domat ass garantéiert, datt:' },
          {
            liste: [
              'MirumGames.com Är Kaartennummer ni gesäit a keen Zougang zu Äre Bankdonnéeën huet',
              'MirumGames.com d’Detailer vun Ären Transaktiounen net kennt — un eis ginn nëmmen de Gesamtbetrag an d’Bestellnummer weiderginn',
              'Är Bankdonnéeën eleng vu STRIPE veraarbecht ginn, engem certifiéierten a vertrauenswürdegen Déngschtleeschter',
            ],
          },
        ],
      },
      {
        titre: 'Wéi eng Sécherheetsmoossnamen huet STRIPE?',
        blocs: [
          { p: 'STRIPE benotzt de standardiséierte Verschlësselungssystem, deen als „SSL-Protokoll“ (Secure Sockets Layer) bekannt ass.' },
          { p: 'Wann Dir op der Bezuelsäit sidd, kontrolléiert dës Sécherheetsindicateuren:' },
          {
            liste: [
              '<strong>Sécherheetssymbol:</strong> an der Eck vun Ärem Browser muss e zouene Schlass erschéngen',
              '<strong>Adressleescht:</strong> d’URL muss mat „https://“ ufänken (net mat „http://“)',
              'Dat „s“ vun https weist op eng séier a verschlësselte Verbindung hin',
            ],
          },
          { p: 'Wann eng Warnung erschéngt, wiesselt Dir vun engem verschlësselte an en onverschlësselte Modus (oder ëmgekéiert). Kontrolléiert dat, ier Dir vertraulech Donnéeën aginn.' },
        ],
      },
      {
        titre: 'Zertifizéierunge vu STRIPE',
        blocs: [
          { p: 'STRIPE erfëllt déi strengst Normen:' },
          {
            liste: [
              '<strong>PCI-DSS</strong> (Payment Card Industry Data Security Standard): héchst Sécherheetszertifizéierung fir Kaartebezuelungen',
              '<strong>DSGVO</strong>: voll Anhale vun der europäescher Reglementatioun',
              '<strong>ISO 27001</strong>: Zertifizéierung fir d’Gestioun vun der Informatiounssécherheet',
              '<strong>SOC 2 Type II</strong>: onofhängegen Sécherheets- a Konformitéitsaudit',
            ],
          },
        ],
      },
      {
        titre: 'Sécherheetsrotschléi',
        blocs: [
          { p: 'Fir sécher ze bezuelen:' },
          {
            liste: [
              '✓ Benotzt ëmmer déi lescht Versioun vun Ärem Browser',
              '✓ Bezuelt nëmmen iwwer séier Verbindungen (net op ongeschütztem ëffentlechem WLAN)',
              '✓ Kontrolléiert ëmmer, ob de Schlass zou ass an d’URL mat „https://“ ufänkt',
              '✓ Deelt Är Bezuelungsdonnéeën ni per E-Mail oder Telefon',
              '✓ Kontrolléiert reegelméisseg Äre Kontoauszuch op verdächteg Bewegungen',
            ],
          },
        ],
      },
      {
        titre: 'Wat geschitt no der Bezuelung?',
        blocs: [
          { p: 'Soubal d’Bezuelung bestätegt ass:' },
          {
            liste: [
              'Dir kritt eng Bestellbestätegung per E-Mail',
              'MirumGames.com kritt nëmmen de Gesamtbetrag an Är Bestellnummer',
              'STRIPE späichert Är Bezuelungsdonnéeë sécher',
              'Är Bestellung gëtt virbereet a verschéckt',
            ],
          },
        ],
      },
      {
        titre: 'Am Fall vun engem Problem',
        blocs: [
          { p: 'Wann Dir verdächteg Bewegungen op Ärem Kont feststellt:' },
          {
            liste: [
              'Kontaktéiert direkt Är Bank',
              `Schéckt eng E-Mail un ${COURRIEL} mat den Detailer vum Problem`,
              'Mellt de Problem direkt bei STRIPE',
            ],
          },
        ],
      },
      {
        titre: 'Dacks gestallte Froen',
        blocs: [
          { p: '<strong>F: Behält MirumGames.com meng Kaartendonnéeën?</strong><br />A: Nee, guer net. Eleng STRIPE verwalt Är Bankdonnéeën.' },
          { p: `<strong>F: Wéi kann ech meng Bezuelungsdonnéeë läsche loossen?</strong><br />A: Kontaktéiert ${COURRIEL}, fir d’Läsche vun Ären Donnéeën ze froen.` },
          { p: '<strong>F: Kann ech méi Bezuelmethode benotzen?</strong><br />A: Jo. STRIPE akzeptéiert Kreditkaarten, Debitkaarten a weider Methoden, jee no Ärem Standuert.' },
        ],
      },
      {
        titre: 'Fir méi Informatiounen',
        blocs: [
          { p: 'Méi Detailer zur Sécherheet bei STRIPE fannt Dir op: <a href="https://stripe.com/security" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">stripe.com/security</a>' },
        ],
      },
    ],
  },
};
